<template>
    <div class="uzhnet-button-component">
        <div class="uzhnet-button-container">
            <div class="uzhnet-button-label">
                <slot></slot>
            </div>
            <svg width="99%" height="200%" viewBox="0 0 357 177" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 3H354V174H3V3Z" fill="#D81159" fill-opacity="0.02"/>
                <line x1="0.5" y1="8" x2="0.5" y2="2.18556e-08" stroke="#D81159"/>
                <line x1="1" y1="0.5" x2="8" y2="0.5" stroke="#D81159"/>
                <line x1="349" y1="0.5" x2="357" y2="0.5" stroke="#D81159"/>
                <line x1="356.5" y1="1" x2="356.5" y2="8" stroke="#D81159"/>
                <line x1="8" y1="176.5" x2="4.37113e-08" y2="176.5" stroke="#D81159"/>
                <line x1="0.5" y1="176" x2="0.5" y2="169" stroke="#D81159"/>
                <line x1="356.5" y1="169" x2="356.5" y2="177" stroke="#D81159"/>
                <line x1="356" y1="176.5" x2="349" y2="176.5" stroke="#D81159"/>
            </svg>
        </div>
    </div>
</template>
<script>
export default {
    name: "UzhnetInput",

    props: {
        fontSize: {
            type: String,
            default: '20px'
        }
    }
}
</script>
<style lang="scss" scoped>
.uzhnet-button-component {
    position: relative;
    height: max-content;
}

.uzhnet-button-container {
    position: relative;
    width: 100vw; /* Розтягує контейнер на всю ширину екрана */
    max-width: 100%; /* Гарантує відсутність обмежень */
    margin: 0;
    height: 100%; /* Висота SVG */
}

.uzhnet-button-label {
    position: absolute;
        top: 0;
    left: 0;
    width: 100%; /* Розтягує input на всю ширину контейнера */
    height: 100%;
    border: none;
    background: transparent;
    font-size: v-bind(fontSize);
    color: #000;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
